
import { Fragment, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SafeDatatable } from "../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCogs,
  faEdit,
  faCopy,
  faTable,
  faTrash,
  faArrowsRotate,
  faExclamationTriangle,
  faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";

import _ from "lodash";

import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import {
  RequestInputOutputParamsModel,
  RequestInputOutputParamsModelDefault,
} from "../../models/requestInputOutputParams.model";
import { TransporterModel } from "../../models/transporter.model";
import { LocaleModel } from "../../models/locale.model";
import { BranchModel } from "../../models/branch.model";

//Sprint 22 - 7731 - Novo Filtro - Status Equipamentos
import { EquipmentStatusModel } from "../../models/equipmentStatus.model";
import EquipmentStatusService from "../../services/equipmentStatus.service";
//Sprint 22 - 7731 - Novo Filtro - Status Equipamentos

import { ErrorHandler } from "../../services/errorHandler.service";
import { ToastService } from "../../services/toast.service";
import { BranchService } from "../../services/branch.service";
import { EquipmentService } from "../../services/equipment.service";
import { TransporterService } from "../../services/transporter.service";
import { LocaleService } from "../../services/locale.service";
import { FileExportService } from "../../services/fileExport.service";
import storageService from "../../services/storage.service";

import { HeaderList } from "../../components/HeaderList";
import { CustomModal } from "../../components/Modal";
import { ModalCopy } from "../../components/ModalCopy";
import { ModalMulticlient } from "../../components/ModalMulticlient";
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
import { ModalReloadPrev } from "../../components/ModalReloadPrev";
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
import ModalImport from "../../components/ModalImport";

import { ButtonClean, ButtonSearch, ButtonReload } from "../../components/buttons";


import {
  DropdownButtonExport,
  DropdownButtonImport,
} from "../../components/dropdownButton";
import UtilService from "../../services/util.service";
import { finished } from "stream";



const EquipmentList = () => {
  const { pathname } = useLocation();
  const user = storageService.getUser();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [data, setData] = useState<DatasetModel>();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: "equipment",
    filters: {
      transporter_id: [],
      branch_id: [],
      locale_id: [],
      code_equipment: [],
      equipment_status_id:[], //Sprint 22 - 7731 - Novo Filtro - Status Equipamentos
      customer: [],
    },
    sort: {
      field: "codeEquipment",
      orientation: "asc",
    },
  });
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [locales, setLocales] = useState<LocaleModel[]>();
  const [branches, setBranches] = useState<BranchModel[]>();

  const [equipmentStatus, setequipmentStatus] = useState<EquipmentStatusModel[]>(); //Sprint 22 - 7731 - Novo Filtro - Status Equipamentos

  const history = useHistory();

  // ---

  const [showImportModal, setShowImportModal] = useState({
    show: false,
    title: "",
  });

  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null,
  });

  const [showModalCopiar, setShowModalCopiar] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null,
  });
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
  const [showModalReloadPrev, setShowModalReloadPrev] = useState(false);
  /* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */

  const [showModalMulticlient, setShowModalMulticlient] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null
  });

  // ---

  const columns = [
    {
      key: "localeName",
      text: t("EQUIPMENT.LOCALE"),
      align: "left",
      sortable: true,
    },
    {
      key: "transporterName",
      text: t("EQUIPMENT.TRANSPORTER"),
      align: "left",
      sortable: true,
    },
    {
      key: "branchNickname",
      text: t("EQUIPMENT.BRANCH"),
      align: "left",
      sortable: true,
    },
    {
      key: "codeEquipment",
      text: t("EQUIPMENT.CODE_EQUIPMENT"),
      align: "left",
      sortable: true,
      cell: (record) => {
        const dateRef = new Date();
        dateRef.setDate(dateRef.getDate() - 23);
        let showIcon = record["usingDefaultHistory"];
        let icon = null;
        if (showIcon && !record["indicadorMulticliente"])
          icon = (<FontAwesomeIcon
            title={t("EQUIPMENT.DEFAULT_HISTORY")}
            style={{ color: "orange" }}
            icon={faTriangleExclamation}
            className='mt-1 fa-lg ml-2'
            />);
        return (<span>
          {record["codeEquipment"]}
          {icon}     
          </span>);
      },
    },
    {
      key: "indicadorMulticliente",
      text: t("EQUIPMENT.EQUIPMENT_MULTI_CLIENTE"),
      align: "left",
      sortable: true,
      cell: (record) => {
        return record.indicadorMulticliente == true ? t("YES") : t("NO");
      },
    },
    {
      key: "parentEquipmentId",
      text: t("EQUIPMENT.ASSOCIED"),
      align: "left",
      sortable: true,
      cell: (record) => {
        return record.parentEquipmentId === null ? t("NO") : t("YES");
      },
    },

    // Sprint 22 - 7728 -  Adicionar na Tela de Equipamentos - Status do Equipamento
    {
      key: "equipmentStatusNickname",
      text: t("EQUIPMENT.STATUS"),
      align: "left",
      sortable: true,
      cell: (record) => {
        return t(
            "EQUIPMENT_STATUS." + record.equipmentStatusNickname
        );
      },
    },
    // Sprint 22 - 7728 -  Adicionar na Tela de Equipamentos - Status do Equipamento
    {
      key: "action",
      text: t("ACTIONS"),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => history.push(`${pathname}/edit/${record.id}`)}>
                    <FontAwesomeIcon icon={faEdit} className='me-2' />
                      {(user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? (
                        t("VIEW")
                      ):
                        t("EDIT")
                      }
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  disabled={record.parentEquipmentId != null || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  onClick={() =>
                    actionShowCopyModal(record.id, record.codeEquipment, record)
                  }>
                  <FontAwesomeIcon icon={faCopy} className='me-2' /> {t("COPY")}
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  onClick={() =>
                    actionRemove(record.id, record.codeEquipment, record)
                  }>
                  <FontAwesomeIcon icon={faTrash} className='me-2' />{" "}
                  {t("DELETE")}
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  disabled={record.parentEquipmentId != null || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  onClick={() => actionShowMulticlientModal(record.id, record.codeEquipment, record)}>
                  <FontAwesomeIcon icon={faTable} className='me-2' /> {t('EQUIPMENT.MULTICLIENT')}
                </Dropdown.Item>    
              {/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */}
                <Dropdown.Item
                  className='fw-bold'
                  disabled={record.parentEquipmentId != null || !record.firstUpdateAt || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  onClick={() => {ReloadPrev(record.codeEquipment);}}>
                  <FontAwesomeIcon icon={faArrowsRotate} className='me-2' /> {t('EQUIPMENT.RECALCULATE_FORECAST')}
                </Dropdown.Item>  
              {/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */}
              </Dropdown.Menu>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [datasetOverride || dataset],
    };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "codeEquipment";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await EquipmentService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(
        _.filter(response.result.datasets, { dataset: "equipment" })
      );
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };
  /* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */

  const handleSearch = async (event) => {

    const trimcodeequipment = dataset.filters.code_equipment?.[0]?.trim() || "";
    const trimcustomer = dataset.filters.customer?.[0]?.trim() || "";

    const cleanedDataset = {
      ...dataset,
      filters: {
        ...dataset.filters,
        code_equipment: [trimcodeequipment],
        customer: [trimcustomer],
      },
    };

    event.preventDefault();
    await getList(null,cleanedDataset);
  };
  const handleSearchEnter = async () => {
    const trimcodeequipment = dataset.filters.code_equipment?.[0]?.trim() || "";
    const trimcustomer = dataset.filters.customer?.[0]?.trim() || "";

    const cleanedDataset = {
      ...dataset,
      filters: {
        ...dataset.filters,
        code_equipment: [trimcodeequipment],
        customer: [trimcustomer],
      },
    };

    await getList(null,cleanedDataset);
  };

  const tableChangeHandler = async (data) => {
      await getList(data);
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
    if (flagClear)
    {
        handleSearchEnter();
        setFlagClear(false);
    }
  }, [flagClear]);

  const handleClean = () => {
    setDataset({
      ...dataset,
      filters: {
        transporter_id: [],
        branch_id: [],
        locale_id: [],
        code_equipment: [],
        equipment_status_id:[],
        customer: []
      },
        sort: {
        field: "",
        orientation: "",
      },
    });
    setFlagClear(true);
  };

  // ---

  const actionRemove = (id, name, entity) => {
    setShowRemoveModal({ id: id, show: true, name: name, entity });
  };
  const handleCloseModal = () =>
    setShowRemoveModal({ id: 0, show: false, name: "", entity: null });

  const actionShowCopyModal = (id, name, entity) => {
    setShowModalCopiar({ id: id, show: true, name: name, entity });
  };
  const handleCloseModalCopiar = () =>
    setShowModalCopiar({ id: 0, show: false, name: "", entity: null });
  const handleExecuteCopy = (equipmentCode, addHistory) => {
    copy(equipmentCode, addHistory);
  };
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
  const handleCloseModalReloadPrev = () =>
        setShowModalReloadPrev(false);
 
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
  const actionShowMulticlientModal = (id, name, entity) => { setShowModalMulticlient({ id: id, show: true, name: name, entity }); };
  const handleCloseModalMulticlient = () => setShowModalMulticlient({ id: 0, show: false, name: "", entity: null });
  const handleExecuteMulticlient = (multiclientQuantity) => {createMulticlient(multiclientQuantity)};

  const actionShowImportModal = (entity, title) => {
    storageService.setImportEntity(entity);
    setShowImportModal({ show: true, title: title });
  };
  const handleCloseImportModal = () => {
    storageService.removeImportEntity();
    setShowImportModal({ show: false, title: "" });
  };

  // ---

  const remove = async () => {
    if (showRemoveModal.id) {
      try {
        const response: any = await EquipmentService.delById(
          showRemoveModal.id
        );
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t("EQUIPMENT.REMOVED"));
            await getList(null);
            handleClean();
            handleCloseModal();
          }
        }
      } catch (error) {}
    } else if (showRemoveModal.entity?.id) {
      try {
        const response: any = await EquipmentService.del(
          showRemoveModal.entity
        );
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t("EQUIPMENT.REMOVED"));
            await getList(null);
            handleClean();
            handleCloseModal();
          }
        }
      } catch (error) {}
    }
  };

  const copy = async (novoCodeEquipment, addHistory) => {
    if (novoCodeEquipment != "") {
      try {
        showModalCopiar.entity.newCodeEquipment = novoCodeEquipment;
        showModalCopiar.entity.addHistory = addHistory;

        const response: any = await EquipmentService.copy(
          showModalCopiar.entity
        );
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t("EQUIPMENT.COPIED"));
            await getList(null);
            handleClean();
            handleCloseModalCopiar();
          }
        }
      } catch (error) {}
    } else {
      ToastService.warn(t("EQUIPMENT.INFORM_CODEQUIPMENT"), null);
    }
  };

  const createMulticlient = async (multiclientQuantity) => {
    if (multiclientQuantity != '') {
      try {
        showModalMulticlient.entity.multiclientQuantity = multiclientQuantity

        const response: any = await EquipmentService.createMulticlient(showModalMulticlient.entity);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('EQUIPMENT.MULTICLIENT_CREATED'));
            await getList(null);
            handleClean();
            handleCloseModalMulticlient();
          }
        }
      } catch (error) { }
    }
    else {
      ToastService.warn(t('EQUIPMENT.INFORM_MULTICLIENT_QUANTITY'), null);
    }
  };
/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */
  const ReloadPrev = async (code_equipment) => {
    try {
      if (isLoading == false)
      {
        setLoading(true);
        let requestParams: RequestInputOutputParamsModel = {
          ...RequestInputOutputParamsModelDefault,
          datasets: [dataset],
        };
        if (code_equipment !== null && requestParams?.datasets) {
          requestParams.datasets[0].filters.code_equipment = [code_equipment];
        };
        const response: any = await EquipmentService.setRecalculate(requestParams);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            handleClean();
            ToastService.success(t('EQUIPMENT.FORECAST_RECALCULATED'));
            handleCloseModalReloadPrev();
          }
          setLoading(false);
        }        
      }

  } catch (error) { }


  };

  const initialize = async () => {
    await getList(null);

    TransporterService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(
          _.filter(response.result.datasets, { dataset: "transporter" })
        );
        const sort = Array.isArray(d?.data)
          ? [...d.data].sort((a, b) => a.fullName.localeCompare(b.fullName))
          : [];
        setTransporters(sort);
      }
    });

    LocaleService.getAll().then((response: any) => {
      setLocales(Array.isArray(response?.result) ? response.result : []);
    });

    BranchService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(
          _.filter(response.result.datasets, { dataset: "branch" })
        );
        const sort = Array.isArray(d?.data)
          ? [...d.data].sort((a, b) => a.fullName.localeCompare(b.fullName))
          : [];
        setBranches(sort);
      }
    });

    //Sprint 22 - 7731 - Novo Filtro - Status Equipamentos
    EquipmentStatusService.getAll().then((response: any) => {
      setequipmentStatus(Array.isArray(response?.result) ? response.result : []);
    });

  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`EQUIPMENT.TITLE_LIST`) } disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <CustomModal
        Title={t("DELETE")}
        Message={`${t("EQUIPMENT.REMOVE_ANSWER")} ${
          showRemoveModal ? showRemoveModal.name : ""
        }?`}
        close={handleCloseModal}
        cancel={t("CANCEL")}
        show={showRemoveModal ? showRemoveModal.show : false}>
        <Button variant='primary' onClick={remove}>
          {t("YES")}
        </Button>
      </CustomModal>
      {/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */}
      <ModalReloadPrev
        Title={t("EQUIPMENT.RECALCULATE_FORECAST")}
        Message= {`${t("EQUIPMENT.RECALCULATE_FORECAST_ANSWER_ALL")}`}
        close={handleCloseModalReloadPrev}
        cancel={t("CANCEL")}
        isLoading={isLoading}
        show={showModalReloadPrev}>
        <Button variant='primary' onClick={() => {ReloadPrev(null);}}>
          {t("YES")}
        </Button>
      </ModalReloadPrev>
      {/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */}
      <ModalCopy
        Title={t("COPY")}
        Message={`${showModalCopiar ? showModalCopiar.name : ""}`}
        close={handleCloseModalCopiar}
        copy={(equipmentCode, addHistory) =>
          handleExecuteCopy(equipmentCode, addHistory)
        }
        cancel={t("CANCEL")}
        show={showModalCopiar ? showModalCopiar.show : false}></ModalCopy>

      <ModalMulticlient
        Title={t('EQUIPMENT.MULTICLIENT')}
        Message={`${showModalMulticlient ? showModalMulticlient.name : ""}`}
        close={handleCloseModalMulticlient}
        createMulticlient={(multiclientQuantity) => handleExecuteMulticlient(multiclientQuantity)}
        cancel={t('CANCEL')}
        show={showModalMulticlient ? showModalMulticlient.show : false}>                
      </ModalMulticlient>
      
      <ModalImport
        title={t(showImportModal.title)}
        close={handleCloseImportModal}
        cancel={t("CLOSE")}
        show={showImportModal ? showImportModal.show : false}></ModalImport>

      <Form>
        <Form.Label>{t("FILTERS")}</Form.Label>
        <Row>
          <Col xs='2' style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Control style={{ display: "none" }}></Form.Control>
              <Form.Floating>
                <Form.Control
                  name='code_equipment'
                  id='code_equipment'
                  type='text'
                  placeholder={t(`FILTER.CODE_EQUIPMENT`)}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({
                      ...dataset,
                      filters: {
                        ...dataset.filters,
                        code_equipment: [e.target.value],
                      },
                    });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearchEnter();
                    }
                  }}
                  value={
                    dataset?.filters?.code_equipment.length > 0
                      ? dataset.filters.code_equipment[0]
                      : ""
                  }
                />
                <label htmlFor='code_equipment'>
                  {t("FILTER.CODE_EQUIPMENT")}
                </label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs='2' style={{padding: '0px 4px'}}>
                                          {/* Input Cliente - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                                          <div onClick={(e) => e.stopPropagation()}>
                                              <Form.Floating>
                                                  <Form.Control
                                                      name='customer'
                                                      id='customer'
                                                      type='text'
                                                      placeholder={t(`FILTER.CLIENT`)}
                                                      className='form-control'
                                                      onChange={(e) => {
                                                          setDataset({
                                                              ...dataset,
                                                              filters: {
                                                                  ...dataset.filters,
                                                                  customer: [e.target.value],
                                                              },
                                                          });
                                                      }}
                                                      /* onKeyDown={(e) => {
                                                          if (e.key === "Enter") {
                                                              handleSearch();
                                                          }
                                                      }} */
                                                      value={
                                                        dataset?.filters?.customer
                                                              .length > 0
                                                              ? dataset.filters.customer[0]
                                                              : ""
                                                      }
                                                  />
                                                  <label>{t("FILTER.CUSTOMER")}</label>
                                              </Form.Floating>
                                          </div>
                                      </Col>

          <Col xs='1' style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={
                    dataset?.filters?.locale_id.length > 0
                      ? dataset.filters.locale_id[0]
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setDataset({
                        ...dataset,
                        filters: { ...dataset.filters, locale_id: [] },
                      });
                    } else {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          locale_id: [Number(e.target.value)],
                        },
                      });
                    }
                  }}>
                  <option value=''>{t("EQUIPMENT.LOCALE")}</option>
                  {_.map(locales, (l: LocaleModel) => {
                    return (
                      <option key={l.id} value={l.id}>
                        {l.name}
                      </option>
                    );
                  })}
                </Form.Control>
                <label htmlFor='status'>{t("EQUIPMENT.LOCALE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs='3' style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={
                    dataset?.filters?.transporter_id.length > 0
                      ? dataset.filters.transporter_id[0]
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value == "")
                    {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          transporter_id: [],
                        },
                      });
                    }
                    else
                    {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          transporter_id: [Number(e.target.value)],
                        },
                      });
                    }
                  }}>
                  <option value=''>{t("EQUIPMENT.TRANSPORTERNAME")}</option>
                  {_.map(transporters, (l: TransporterModel) => {
                    return (
                      <option key={l.id} value={l.id}>
                        {l.fullName}
                      </option>
                    );
                  })}
                </Form.Control>
                <label htmlFor='status'>{t("EQUIPMENT.TRANSPORTERNAME")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs='2' style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={
                    dataset?.filters?.branch_id.length > 0
                      ? dataset.filters.branch_id[0]
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value == "")
                    {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          branch_id: [],
                        },
                      });
                    }
                    else
                    {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          branch_id: [Number(e.target.value)],
                        },
                      });
                    }
                  }}>
                  <option value=''>{t("EQUIPMENT.BRANCH")}</option>
                  {_.map(branches, (l: BranchModel) => {
                    return (
                      <option key={l.id} value={l.id}>
                        {l.fullName}
                      </option>
                    );
                  })}
                </Form.Control>
                <label htmlFor='status'>{t("EQUIPMENT.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          {/* Sprint 22 - 7731 - Novo Filtro - Status Equipamentos */}
          <Col xs='2' style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={
                    dataset?.filters?.equipment_status_id.length > 0
                      ? dataset.filters.equipment_status_id[0]
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value == "")
                    {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          equipment_status_id: [],
                        },
                      });
                    }
                    else
                    {
                      setDataset({
                        ...dataset,
                        filters: {
                          ...dataset.filters,
                          equipment_status_id: [Number(e.target.value)],
                        },
                      });
                    }
                  }}>
                  <option value=''>{t("EQUIPMENT.STATUS")}</option>
                  {_.map(equipmentStatus, (l: EquipmentStatusModel) => {
                    return (
                      <option key={l.id} value={l.id}>

                        {t('EQUIPMENT_STATUS.' + l.nickname.toUpperCase().toString().trimEnd() )}
                      </option>
                    );
                  })}
                </Form.Control>
                <label htmlFor='status'>{t("EQUIPMENT.STATUS")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
          {/* Sprint 22 - 7731 - Novo Filtro - Status Equipamentos */}

        </Row>
        <br></br>
        <Row>
          <Col xs='auto'>
            <ButtonSearch onClick={(e) => handleSearch(e)} />
          </Col>

          <Col xs='auto'>
            <ButtonClean
              onClick={async (e) => {
                e.preventDefault();
                handleClean();
              }}
            />
          </Col>

          <Col xs='auto'>
            <DropdownButtonImport
              onClick={(entity, title) => actionShowImportModal(entity, title)}
              disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
            />
          </Col>

          <Col xs='auto'>
            <DropdownButtonExport
              onClick={(type: string) => {
                setLoading(true);
                FileExportService.Export(
                  {
                    ...RequestInputOutputParamsModelDefault,
                    datasets: [dataset],
                  },
                  "Equipment",
                  type
                ).finally(() => {
                  setLoading(false);
                });
              }}
              isLoading={isLoading}
            />
          </Col>

      {/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */}
          <Col className="d-flex justify-content-end">
            <ButtonReload
              disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
              onClick={async (e) => {
                  setDataset({
                    ...dataset,
                    filters: {
                      ...dataset.filters,
                      code_equipment: [],
                    },
                  });
                  setShowModalReloadPrev(true);
              }}
              isLoading={isLoading}
            />
          </Col>
      {/* sprint 22 - 8339 - Recalculo da previs�o de saldo dos cofres (calc_regression) */}
        </Row>
      </Form>
      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={
          data?.pagination?.total_records ? data?.pagination?.total_records : 0
        }
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
      />
    </>
  );
};

export default EquipmentList;
